/*
  中文
*/
export default {
  orderList: {
    AllOrder: '所有订单',
    WaitingPayment: '待付款',
    Pending: '待发货',
    ToBeSighed: '在途中',
    Refunding: '退款中',
    YouHave: '你有',
    orders: '订单',
    OrderID: '订单号',
    Customer: '顾客',
    coupon: '优惠码',
    TotalAmount: '总金额',
    PayNow: '现在付款',
    ViewDetails: '查看详细',
    CancelOrder: '取消订单',
    Delete: '删除',
    selectContent: '请选择',
    startDate: '开始时间',
    endDate: '结束时间',
    inputPlaceholder: '按订单ID、SKU或产品名称搜索',
    RequestRefund: '要求退款',
    ConfirmReceipt: '确认收到',
    CancelReason: '取消理由',
    Verification: '验证',
    RefundReason: '退款理由',
    Remake: '备注',
    cancel: '取消',
    submit: '提交',
    ConfirmReceiptTitle: '你确定你已经收到货物并且质量符合交易双方的协议吗？',
    ConfirmReceiptContent: '如果确认无误，请点击下面的“确认”按钮完成收货确认。',
    removeTheStore: '移除店铺',
    CancellationReasonIsRequired: '取消原因必填',
    RefundReasonIsRequired: '退款原因必填',
    Paypal: 'Paypal',
    CreditCard: '信用卡',
    Balance: '余额',
    SelectByStatus: '按状态选择',
    SelectByPlatform: '按平台选择',
    FulfillOrder: '完成订单',
    Store: '店铺',
    StoreOrderID: '店铺订单ID',
    TrackingNumber: '查询号',
    ShippingCarrier: '承运人',
    TrackingURL: '追踪网址',
    cancelBtn: '取消',
    ok: '完成',
    emptyTips1: '你的订单是空的！',
    emptyTips2: '您可以在这里管理和处理订单',
    ChooseProduct: '选择产品',
    ChooseProductTips: '如何查找和列出产品',
    ConnectANewStore: '连接新店',
    ConnectANewStoreTips: '如何连接新店',
    selectAll: '全选',
    orderStatusSubTip: '退款失败，请联系我们的支持团队'
  },
  orderDetail: {
    PayNow: '现在付款',
    ConfirmReceipt: '确认收到',
    StoreOrderID: '商店订单ID',
    OrderID: '订单号',
    Source: '来源',
    IncomeStatement: '损益表',
    CommodityInformation: '商品信息',
    ShipFrom: '从',
    ItemNo: '项目编号',
    TheDetail: '详情',
    Notes: '笔记',
    OrderStatus: '订单状态',
    BalancePayment: '收支平衡',
    PaymentTime: '付款时间',
    PaymentId: '付款ID',
    ItemSubtotal: '小计',
    ShippingSubtotal: '运输',
    tax: '税',
    PaymentAmount: '付款金额',
    ShippingAddress: '送货地址',
    ConfirmReceiptModalTitle: '你确定你已经收到货物并且质量符合交易双方的协议吗？',
    ConfirmReceiptModalContent: '如果确认无误，请点击下面的“确认”按钮完成收货确认。',
    Cancel: '取消',
    Submit: '提交',
    removeTheStore: '移除存储',
    WaitingPayment: '等待付款',
    WaitingPaymentTips: '您的订单还没有付款。单击“立即付款”继续。',
    OrderCreation: '订单创建',
    Finish: '完成',
    PaymentSuccessful: '付款成功',
    IncorrectAddressInformation: '地址信息不正确',
    CancelTips: '您的订单已成功取消',
    Pending: '待发货',
    PendingSecondStatus: '通常不超过24小时。订单发货后，我们会通知您',
    PendingTips: '每一件产品在发送给您的客户之前都经过我们严格的质量检查。',
    Shipped: '装船',
    Complete: '完成',
    ShippedTips1: '你的订单马上就到！',
    PartialDelivery: '部分交货',
    ShippedTips2: '您的一些产品尚未发货',
    Refunding: '退款',
    PartialRefund: '部分退款',
    refundedTipsNew: '您订单的总退款金额为',
    RefundingSecondStatus: '您的退款将在1-3个工作日内处理',
    RefundingTips: '退款申请已提交。等待处理',
    Refund: '退款',
    Refunded: '已退款',
    RefundedSecondStatus: '根据您的金融机构，资金在您的账户中显示最多需要14天',
    RefundedTips: '退款请求已被接受。已支付的金额将按原支付方式退还',
    CompleteSecondStatus: '交易完成',
    CompleteTips: '订单已经完成，谢谢您的支持',
    ShippingMethod: '运输方式',
    MyOrder: '我的订单',
    OrderInformation: '订单信息',
    Product: '产品',
    PurchasePrices: '购买价格',
    prices: '价格',
    Quantity: '数量',
    Subtotal: '小计',
    Profit: '利润',
    ConfirmReceiptTips: '注意收据',
    trackingCode: '跟踪码',
    DeliveryTime: '交货时间',
    logisticsProviders: '物流供应商',
    payment: '付款',
    NotToDeliverGoods: '不送货',
    LogisticsInformation: '物流信息',
    PartialDeliveryTips: '部分产品尚未发货，发货后我们会通知您',
    PaymentInformation: '付款信息',
    Balance: '余额',
    CreditCard: '信用卡',
    payFail: '支付失败',
    Remaining: '剩余时间',
    WaitingPaymentWarning: '超过120小时未付款的订单将被取消',
    OrderCancelled: '订单取消',
    OrderConfirmed: '订单确认',
    Shipping: '航运',
    OrderComplete: '已交付',
    OrderSubmitted: '提交的订单',
    PleaseInput: '请输入',
    Note: '备注',
    EditNote: '编辑备注',
    Edit: 'Edit',
    EditNoteSuccessTip: '备注内容更新成功。',
    NoteTip: '这是笔记的内容。'
  }
}
